
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexEeZ8gVJxcqby_Edab03sAfzMVIMRFjxPrlZlV9mdaHIMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/index.vue?macro=true";
import { default as indexktbg6EnaWqpnZMkvkA_45p5pIiSERJ8GdE8j_sw7eZx5oMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/cart/index.vue?macro=true";
import { default as index8SHjgvQS8K97SKoBErVhoRmR9a51NqBp7hybmZmiJ_45sMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/login/index.vue?macro=true";
import { default as indexuqCWdx_g6tCDLx2i4RfPa97NH9Ani8wYswj7JeTbwvkMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/logout/index.vue?macro=true";
import { default as indexO6p_uqAfx0WaxHF5pI7756PZCchvjZBPGEhyPnjvU1sMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/contact/index.vue?macro=true";
import { default as index_4501t39KtyaN6Ec51vwyTuHbIYVOqesYzSJxeIRfH8JoMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/checkout/index.vue?macro=true";
import { default as indexf7jXdEQWkBn29Cslh4janGlKaIHaFg2F5Hf03MpDUvoMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/myorders/index.vue?macro=true";
import { default as indexLTGP9XMYI5dA22xWCEHCvWdb8Wkg2opUKebudzPP43YMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/index.vue?macro=true";
import { default as indexOzj4qTI_6GB4o07yPx3WnDwc0ogDMC0qSVz163n6yiMMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/lookbooks/index.vue?macro=true";
import { default as list1hHMsUWRacNFYK2GRB6E_45LqNZLakgabQlnPaGE2LKlUMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/ra-support/list.vue?macro=true";
import { default as index0SQTATIqxHSnFZnmZJfAsiUApAwtiBp7Y1YcautER_45EMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/openOrders/index.vue?macro=true";
import { default as indexr0OltRSTTksAwWP3XA_cAUEg4fOvqbIqcXHS_T1i6O4Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/ra-support/index.vue?macro=true";
import { default as indexlHIrkyqoViuPxyJJ05sQesDHURsLBTSbEDBNubZX45QMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/statements/index.vue?macro=true";
import { default as indexDs4Lv4aVWLzFlAgMxY_eOiDgVs7VSY3dq3yQW1LdoTEMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/tradeshows/index.vue?macro=true";
import { default as indexE0Dx3nOafVPpPg6MW_K7Xqyx616LlYD36QagdtSI8OcMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/admin/login/index.vue?macro=true";
import { default as index278WiT1cuFrlltXyyxrlI_45zIqQ52jyMfGHri9y3b1d0Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/creditMemos/index.vue?macro=true";
import { default as createE7MIIg0DOKTBmIpnqYKzyJdLYPEEedwL6m4_45LGDM7_45QMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/ra-support/create.vue?macro=true";
import { default as categorypDtjW33Y3635_RE7dOkQ8KiSwWkqRLZwC_GQ_45Ld2CyoMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/category.vue?macro=true";
import { default as resetPassword_45idzeGU880_L2pgA9FschtTfF_6YLVypcw_45l_4519speAMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/user/resetPassword.vue?macro=true";
import { default as list5LDTguMoOBdKbCc_45dEscDkx_QSOtlv2YCL9Kr1sQelMMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/style/list.vue?macro=true";
import { default as indexsUWs9QIL8PyhYTYAuJiY1_45Rdna20Q1f8yfMAWMiWeuAMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/color/index.vue?macro=true";
import { default as indexUlwZ64felAWL_45PyQZ1mBoVT2LmO1yZdJGA8BqncAxLgMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/style/index.vue?macro=true";
import { default as indexwTTRNab1RhbLdTxRcRxFsT3OLlptsf9j3tcmbPDdQVgMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/barcode/index.vue?macro=true";
import { default as _91productNo_938dtgwXLhzhwB6JStxF9mNQgFPvo78P6z3bz_45LWV869MMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/style/[productNo].vue?macro=true";
import { default as colorAndSizeChartsCV9lnajMHujQqM1wN_458fZOf4k5vaRo_DLIYHbLh2jesMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/colorAndSizeCharts.vue?macro=true";
import { default as indexSb0HsPcql_454bQWInznWOkMTJgQe7PSKmvfi70byKK4YMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/sizeAndColor/index.vue?macro=true";
import { default as indexmZ9K392h3MavIGJOL5P_459cQjjWoJ_1I2HicMzdnI7_45MMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/PriceAndColorAndSize/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexEeZ8gVJxcqby_Edab03sAfzMVIMRFjxPrlZlV9mdaHIMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/cart/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/login/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: indexuqCWdx_g6tCDLx2i4RfPa97NH9Ani8wYswj7JeTbwvkMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/logout/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/contact/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/checkout/index.vue")
  },
  {
    name: "myorders",
    path: "/myorders",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/myorders/index.vue")
  },
  {
    name: "inventory",
    path: "/inventory",
    meta: indexLTGP9XMYI5dA22xWCEHCvWdb8Wkg2opUKebudzPP43YMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/index.vue")
  },
  {
    name: "lookbooks",
    path: "/lookbooks",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/lookbooks/index.vue")
  },
  {
    name: "ra-support-list",
    path: "/ra-support/list",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/ra-support/list.vue")
  },
  {
    name: "openOrders",
    path: "/openOrders",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/openOrders/index.vue")
  },
  {
    name: "ra-support",
    path: "/ra-support",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/ra-support/index.vue")
  },
  {
    name: "statements",
    path: "/statements",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/statements/index.vue")
  },
  {
    name: "tradeshows",
    path: "/tradeshows",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/tradeshows/index.vue")
  },
  {
    name: "admin-login",
    path: "/admin/login",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/admin/login/index.vue")
  },
  {
    name: "creditMemos",
    path: "/creditMemos",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/creditMemos/index.vue")
  },
  {
    name: "ra-support-create",
    path: "/ra-support/create",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/ra-support/create.vue")
  },
  {
    name: "inventory-category",
    path: "/inventory/category",
    meta: categorypDtjW33Y3635_RE7dOkQ8KiSwWkqRLZwC_GQ_45Ld2CyoMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/category.vue")
  },
  {
    name: "user-resetPassword",
    path: "/user/resetPassword",
    meta: resetPassword_45idzeGU880_L2pgA9FschtTfF_6YLVypcw_45l_4519speAMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/user/resetPassword.vue")
  },
  {
    name: "inventory-style-list",
    path: "/inventory/style/list",
    meta: list5LDTguMoOBdKbCc_45dEscDkx_QSOtlv2YCL9Kr1sQelMMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/style/list.vue")
  },
  {
    name: "inventory-color",
    path: "/inventory/color",
    meta: indexsUWs9QIL8PyhYTYAuJiY1_45Rdna20Q1f8yfMAWMiWeuAMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/color/index.vue")
  },
  {
    name: "inventory-style",
    path: "/inventory/style",
    meta: indexUlwZ64felAWL_45PyQZ1mBoVT2LmO1yZdJGA8BqncAxLgMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/style/index.vue")
  },
  {
    name: "inventory-barcode",
    path: "/inventory/barcode",
    meta: indexwTTRNab1RhbLdTxRcRxFsT3OLlptsf9j3tcmbPDdQVgMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/barcode/index.vue")
  },
  {
    name: "inventory-style-productNo",
    path: "/inventory/style/:productNo()",
    meta: _91productNo_938dtgwXLhzhwB6JStxF9mNQgFPvo78P6z3bz_45LWV869MMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/style/[productNo].vue")
  },
  {
    name: "inventory-colorAndSizeCharts",
    path: "/inventory/colorAndSizeCharts",
    meta: colorAndSizeChartsCV9lnajMHujQqM1wN_458fZOf4k5vaRo_DLIYHbLh2jesMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/colorAndSizeCharts.vue")
  },
  {
    name: "inventory-sizeAndColor",
    path: "/inventory/sizeAndColor",
    meta: indexSb0HsPcql_454bQWInznWOkMTJgQe7PSKmvfi70byKK4YMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/sizeAndColor/index.vue")
  },
  {
    name: "inventory-PriceAndColorAndSize",
    path: "/inventory/PriceAndColorAndSize",
    meta: indexmZ9K392h3MavIGJOL5P_459cQjjWoJ_1I2HicMzdnI7_45MMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_STARIELLE/src/pages/inventory/PriceAndColorAndSize/index.vue")
  }
]